import { useCallback } from "react";
import { canAccess } from "@clevis/shared-types";
import { useAuth } from "./useAuth";

// The menu and every page ask the same question the server does: may this
// person see this section? (role defaults + the owner's deny/grant lists)
export function useAccess(): (sectionId: string) => boolean {
  const { role, superAdmin, access } = useAuth();
  return useCallback(
    (sectionId: string) => superAdmin || canAccess(role, sectionId, access),
    [role, superAdmin, access],
  );
}
